<circ-loader *ngIf="loading"></circ-loader>
<div *ngIf="!loading">
  <ng-container *ngComponentOutlet="providerComponent"></ng-container>
</div>
